import React from 'react'
import './Icon.module.css'
import spriteSvg from "../../svg/sprite.svg"

function Icon (props) {

  let renderedIcon;
  if (props.id) {
      renderedIcon = (
        <svg className={props.className} style={props.style}>
          <use xlinkHref={`${spriteSvg}#${props.id}`}/>
        </svg>
      )
    }

    if (props.path) {
      // Default sicuro: se il chiamante non passa `alt`, React non emetterebbe
      // affatto l'attributo, producendo un <img> senza testo alternativo
      // (WCAG 1.1.1). Con la stringa vuota l'immagine e' dichiarata decorativa
      // e viene ignorata dagli screen reader. I chiamanti in cui l'immagine
      // veicola informazione valorizzano `alt` esplicitamente.
      // Nessun onClick: un <img onClick> non e' raggiungibile ne' attivabile da
      // tastiera (WCAG 2.1.1). L'unico chiamante che lo usava (Table.js, icona del
      // telefono) ora avvolge l'icona in un <button>. Non ripristinare la prop:
      // per rendere cliccabile un'icona va sempre usato un <button> attorno.
      renderedIcon = (
        <img id={props.id} className={props.className} style={props.style} height={props.height} width={props.width} src={props.path} alt={props.alt ?? ""}/>)
    }

    return renderedIcon
}
export default Icon
